import { Component, Injector, Input } from "@angular/core";
import { Router } from "@node_modules/@angular/router";
import { AppComponentBase } from "@shared/app-component-base";
import { PacienteDto, PacienteGroupDto, ProfissionalSaudeDto, TipoUsuarioEnum } from "@shared/service-proxies/service-proxies";

@Component({
    selector: 'perfil',
    templateUrl: './perfil.component.html',
    styleUrls: ['./perfil.component.scss'],
})
export class PerfilComponent extends AppComponentBase {
    @Input() expanded: boolean = false;
    @Input() paciente: PacienteGroupDto;
    @Input() profissional: ProfissionalSaudeDto;

    constructor(injector: Injector,private router: Router) { super(injector) }

    protected get tipoUsuario(): string {
        if (this.showPaciente) {
            return 'Paciente';
        }

        if (this.showProfissional) {
            return 'Profissional de Saúde';
        }

        return 'Outro';
    }

    protected get nome(): string {
        if (this.showProfissional) {
            return this.profissional.nome;
        }

        if (this.showPaciente) {
            return this.paciente.nome;
        }
        return "";
    }

    protected get showPaciente(): boolean {
        return this.appSession.user.tipoUsuarioEnum === TipoUsuarioEnum._2;
    }

    protected get showProfissional(): boolean {
        return this.appSession.user.tipoUsuarioEnum === TipoUsuarioEnum._0;
    }

    openProntuario(paciente: PacienteDto): void {
        const urlTree = this.router.createUrlTree([
            'app',
            "profissional-saude",
            'prontuario',
            paciente.id
        ]);

        const url = this.router.serializeUrl(urlTree);
        const fullUrl = window.location.origin + url;

        window.open(fullUrl, '_blank');
    }

}
